var map = {
	"./images-offers/acquiring.png": 36014,
	"./images-offers/exception.png": 5746,
	"./images-offers/image1.png": 86411,
	"./images-offers/image2.png": 18885,
	"./images-offers/image3.png": 29094,
	"./images-offers/image4.png": 36282,
	"./images-offers/image6.png": 70823,
	"./images-offers/image7.png": 66686,
	"./images-offers/kyc.svg": 45686,
	"./images-offers/quickDeposit.png": 77833,
	"./images-offers/quickDepositMobile.png": 76242,
	"./images-offers/referralProgram.png": 69741,
	"./images-offers/services.png": 1758,
	"./images-offers/support.png": 62514,
	"./images-offers/welcome.png": 13815,
	"./images/2FAOval.svg": 22709,
	"./images/2faImg.svg": 90691,
	"./images/Cancelled.svg": 36074,
	"./images/CardActiveOvalWhite.svg": 17067,
	"./images/CardFrozenOvalWhite.svg": 17537,
	"./images/CardOvalGray.svg": 8520,
	"./images/CreditCards.svg": 91911,
	"./images/Failed.svg": 35699,
	"./images/Finnished.svg": 73615,
	"./images/PDF-preview.svg": 82328,
	"./images/Pending.svg": 24945,
	"./images/Processing.svg": 66768,
	"./images/Reverted.svg": 82167,
	"./images/TradingDesk.svg": 58679,
	"./images/aboutImgOne.png": 58631,
	"./images/aboutImgTwo.png": 23812,
	"./images/accountProfileMenu.svg": 22171,
	"./images/active-programme.svg": 68395,
	"./images/add-account.svg": 71888,
	"./images/addMoneyOval.svg": 8964,
	"./images/addPerson.svg": 28919,
	"./images/addedPerson.svg": 49362,
	"./images/address.svg": 41302,
	"./images/alert-error.svg": 37515,
	"./images/alert-info.svg": 76706,
	"./images/alert-warning-yellow.svg": 57989,
	"./images/alert-warning.svg": 69978,
	"./images/arrowDown.png": 83630,
	"./images/arrowKeyboardRight.svg": 37558,
	"./images/arrowLeft.svg": 63155,
	"./images/arrowUp.svg": 62880,
	"./images/attachFilesPlus.svg": 16389,
	"./images/availableCards/physicalBlack.png": 79522,
	"./images/availableCards/physicalGoldGTI.png": 67579,
	"./images/availableCards/physicalHills.png": 86018,
	"./images/availableCards/physicalPheonixBlack.png": 93071,
	"./images/availableCards/physicalPhoenixWhite.png": 43438,
	"./images/availableCards/physicalPlatinumGTI.png": 5701,
	"./images/availableCards/physicalStandardGTI.png": 99937,
	"./images/availableCards/virtualBlack.png": 54618,
	"./images/availableCards/virtualDefault.png": 63329,
	"./images/availableCards/virtualFoxpay.png": 19619,
	"./images/availableCards/virtualGTI.png": 39383,
	"./images/availableCards/virtualHills.png": 16712,
	"./images/availableCards/virtualPhoenix.png": 89128,
	"./images/bankAcc.svg": 60200,
	"./images/bankAccountOvalWhite.svg": 41088,
	"./images/bankAccountRoundDarkGrey.svg": 20472,
	"./images/bankAccountRoundGrey.svg": 1116,
	"./images/basketGrey.svg": 51229,
	"./images/blueArrowDown.svg": 45685,
	"./images/blueArrowUp.svg": 99637,
	"./images/business.svg": 52714,
	"./images/businessProfile.svg": 58800,
	"./images/buyAsstesOval.svg": 327,
	"./images/buyCardOval.svg": 61257,
	"./images/calendar.svg": 64589,
	"./images/card.svg": 11010,
	"./images/cardBackCVC.svg": 83266,
	"./images/cardDeactivate.svg": 36882,
	"./images/cardFreeze.svg": 58473,
	"./images/cardHideDetails.svg": 79295,
	"./images/cardHidePin.svg": 32386,
	"./images/cardShowDetails.svg": 23757,
	"./images/cardShowPin.svg": 67990,
	"./images/cardUnfreeze.svg": 91088,
	"./images/check.svg": 38698,
	"./images/check_circle.svg": 8755,
	"./images/checked-grey-circle.svg": 28271,
	"./images/checked-grey-hover.svg": 96715,
	"./images/checked-grey.svg": 64856,
	"./images/close.svg": 79022,
	"./images/closeButton.svg": 30146,
	"./images/commentCloud.svg": 76889,
	"./images/confirmAddress.svg": 51661,
	"./images/contact.png": 13038,
	"./images/contactImgOne.png": 32613,
	"./images/copy-icon.svg": 49606,
	"./images/credit-card-dark-grey.svg": 55634,
	"./images/dashboardLinkIcon.svg": 27950,
	"./images/deactive.svg": 30683,
	"./images/deviceBrowser.svg": 8453,
	"./images/deviceCardsApp.svg": 91733,
	"./images/deviceMobileApp.svg": 1666,
	"./images/document-upload-thumb.svg": 24950,
	"./images/document.svg": 11402,
	"./images/documents.svg": 71117,
	"./images/downloadFileIcon.svg": 88118,
	"./images/downloadOval.svg": 72116,
	"./images/dragndropmark.svg": 35069,
	"./images/dropZoneUpload.svg": 45711,
	"./images/edit.svg": 17285,
	"./images/email-confirm.png": 30235,
	"./images/email2fa.svg": 66497,
	"./images/error-circle.svg": 93151,
	"./images/errors/403.png": 65055,
	"./images/errors/404.png": 76348,
	"./images/errors/503.png": 35640,
	"./images/errors/serverError.svg": 4391,
	"./images/errors/serverOffline.svg": 11866,
	"./images/exchangeOval.svg": 70433,
	"./images/failure-circle.svg": 30472,
	"./images/favourite.svg": 55835,
	"./images/favouriteBordered.svg": 98216,
	"./images/file-icon-oval.svg": 59558,
	"./images/floatingCard.svg": 68597,
	"./images/foxPayCheck.svg": 87467,
	"./images/freeze.svg": 23142,
	"./images/generic.svg": 90508,
	"./images/google-authenticator.svg": 93057,
	"./images/hammer.svg": 57775,
	"./images/hide-pin.svg": 58665,
	"./images/inactive-programme.svg": 41934,
	"./images/lang/ar.svg": 56936,
	"./images/lang/cn.svg": 1679,
	"./images/lang/de.svg": 41710,
	"./images/lang/en.svg": 88944,
	"./images/lang/es.svg": 3587,
	"./images/lang/fr.svg": 39907,
	"./images/lang/in.svg": 62819,
	"./images/lang/it.svg": 88753,
	"./images/lang/lt.svg": 22255,
	"./images/lang/ru.svg": 48043,
	"./images/lang/tr.svg": 49331,
	"./images/ledgers/adaOval.svg": 52961,
	"./images/ledgers/aedOval.svg": 31065,
	"./images/ledgers/air777Oval.svg": 7796,
	"./images/ledgers/atriOval.svg": 84998,
	"./images/ledgers/btcIcon.svg": 47442,
	"./images/ledgers/btcOval.svg": 34916,
	"./images/ledgers/chfOval.svg": 32180,
	"./images/ledgers/cruOval.svg": 76491,
	"./images/ledgers/dogeOval.svg": 70064,
	"./images/ledgers/dwrldOval.svg": 45205,
	"./images/ledgers/eosOval.svg": 55023,
	"./images/ledgers/ethOval.svg": 89080,
	"./images/ledgers/eurOval.svg": 98092,
	"./images/ledgers/ftmOval.svg": 35252,
	"./images/ledgers/gbpOval.svg": 98246,
	"./images/ledgers/gxagOval.svg": 14807,
	"./images/ledgers/lif3Oval.svg": 65332,
	"./images/ledgers/mt760Oval.svg": 62412,
	"./images/ledgers/mt777Oval.svg": 97408,
	"./images/ledgers/paugOval.svg": 27072,
	"./images/ledgers/pauxOval.svg": 37839,
	"./images/ledgers/rlxOval.svg": 4647,
	"./images/ledgers/sgdOval.svg": 92078,
	"./images/ledgers/shibOval.svg": 71892,
	"./images/ledgers/solOval.svg": 84254,
	"./images/ledgers/trxOval.svg": 56118,
	"./images/ledgers/untbOval.svg": 67993,
	"./images/ledgers/usdOval.svg": 55215,
	"./images/ledgers/usdcOval.svg": 83799,
	"./images/ledgers/usdtOval.svg": 31759,
	"./images/ledgers/usduOval.svg": 7106,
	"./images/ledgers/vetOval.svg": 8346,
	"./images/ledgers/wbtcOval.svg": 68705,
	"./images/ledgers/wcruOval.svg": 3510,
	"./images/ledgers/xagOval.svg": 40594,
	"./images/ledgers/xauOval.svg": 66805,
	"./images/ledgers/xptOval.svg": 97959,
	"./images/ledgers/xrpOval.svg": 19949,
	"./images/limitedTokensServices.svg": 59283,
	"./images/linkingAccount.png": 88500,
	"./images/logout.svg": 83412,
	"./images/mastercardLogo.svg": 27821,
	"./images/metalServices.svg": 55569,
	"./images/metals.svg": 77319,
	"./images/navBar.svg": 23224,
	"./images/note.svg": 21185,
	"./images/otherServices.svg": 42007,
	"./images/package.svg": 75778,
	"./images/pencil.svg": 29236,
	"./images/personalProfile.svg": 46545,
	"./images/phone2Fa.svg": 82760,
	"./images/physicalcardOval.svg": 10430,
	"./images/pin-code.svg": 13760,
	"./images/plus-active.svg": 23683,
	"./images/plus-dark-grey.svg": 70508,
	"./images/plus-grey.svg": 62154,
	"./images/plus-white.svg": 43530,
	"./images/priceTag.svg": 23587,
	"./images/printOval.svg": 33989,
	"./images/profile-circle-active.svg": 60467,
	"./images/profile-oval-dark-grey.svg": 81660,
	"./images/profile-oval.svg": 26417,
	"./images/profile.svg": 39010,
	"./images/referral/1.svg": 28159,
	"./images/referral/2.svg": 67879,
	"./images/referral/3.svg": 59664,
	"./images/referral/facebook.svg": 9228,
	"./images/referral/finish.svg": 5137,
	"./images/referral/linkedin.svg": 55387,
	"./images/referral/success.svg": 73767,
	"./images/referral/twitter.svg": 61858,
	"./images/referral/whatsapp.svg": 40402,
	"./images/referralsIcon.svg": 96030,
	"./images/refresh.svg": 77221,
	"./images/refreshGrey.svg": 24255,
	"./images/refund.svg": 14487,
	"./images/security-warn-fab.svg": 56278,
	"./images/selectDropDownArrow.svg": 39692,
	"./images/sellOval.svg": 84913,
	"./images/sepaOval.svg": 9953,
	"./images/servicePlans/cards.svg": 91977,
	"./images/servicePlans/crypto.svg": 8901,
	"./images/servicePlans/ibans.svg": 65237,
	"./images/servicePlans/metals.svg": 23202,
	"./images/servicePlans/plan_bg.png": 54857,
	"./images/servicePlans/stocks.svg": 3063,
	"./images/settingsLinkIcon.svg": 61309,
	"./images/shipping.svg": 74092,
	"./images/sourceOfFunds.svg": 91690,
	"./images/success-circle-gray.svg": 2169,
	"./images/success-circle.svg": 34108,
	"./images/successBig.svg": 98806,
	"./images/support.svg": 5098,
	"./images/supportIconOvalWhite.svg": 89751,
	"./images/swiftOval.svg": 24260,
	"./images/switchAccount.svg": 43197,
	"./images/tooltip-info.svg": 12697,
	"./images/trading-desk-logo.svg": 96788,
	"./images/transactionsLinkIcon.svg": 34527,
	"./images/transfer.svg": 32288,
	"./images/transferOval.svg": 83948,
	"./images/truck-circle.svg": 29765,
	"./images/truck.svg": 93525,
	"./images/ukLocalOval.svg": 50280,
	"./images/unfreeze.svg": 37363,
	"./images/upload-documents.svg": 38746,
	"./images/virtualcardOval.svg": 59884,
	"./images/visaLogo.svg": 87772,
	"./images/visibility-off.svg": 5902,
	"./images/visibility-on.svg": 32334,
	"./images/waiting.svg": 76993,
	"./images/warning-triangle.svg": 35336,
	"./images/warningCloud.svg": 39913,
	"./images/x.svg": 33420,
	"./images/x_hover.svg": 86954,
	"./images/x_red.svg": 40478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3801;